import React from 'react';
import Spinner, { spinnerPositions } from '~c/ui/Loader';

export const Button = (props) => {
	return (
    <button
      disabled={props.disabled}
      className={props.className || `btn btn--${props.extraClass || 'primary'}`}
      type="button"
      onClick={props.onClick}
    >
      {props.isPending && (
        <Spinner
          className={`loader--${props.extraLoaderClass || 'white'}`}
          spinnerPosition={spinnerPositions.absolute}
        />
      )}
      <span className={props.isPending ? 'invisible' : ''}>{ props.children }</span>
    </button>
	);
};